module.exports = __webpack_public_path__ + "img/photo-0118.21b4acd8.jpg";